<template>
    <div>
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px" viewBox="0 0 100 100" style="enable-background:new 0 0 100 100;" xml:space="preserve"><path :fill="fill" d="M50,4C24.5,4,4,24.5,4,50c0,25.3,20.6,46,46,46s46-20.7,46-46C96,24.5,75.5,4,50,4z M74.6,38.4L42.7,70.2  L24.9,52.4l6.1-5.9l11.8,11.8L69.1,32l6.1,6.1L74.6,38.4z"></path></svg>
    </div>
</template>

<script>
    export default {
        name: "icon-check-round",
        props: {
            fill: {type: String, default: "#000"}
        }
    }
</script>

<style scoped>


</style>